import qs from "query-string";

export const navigateExternal = (url: string, query = {}): void => {
    const stringQuery = qs.stringify(query);
    window.location.href = `${url}?${stringQuery}`;
};
